/**
 * Function to create a properties object for input components.
 *
 * @template T - A generic type that extends InputProps, to support different input property types.
 * @param {string} name - The name of the input field, used for setting the id and name of the input component.
 * @param {string} value - The current value of the input field.
 * @param {string} label - Form elemet label.
 * @param {(event: React.ChangeEvent<HTMLInputElement>) => void} onChange - The function to be called when the input value changes.
 * @param {string | null | undefined} errorText - The error text to be displayed on the input component.
 * @returns {T} - The properties object, casted to the type T.
 */
export function useCreateInputProps<T>(props: {
  name: string;
  value: string;
  errorText: string | null | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
}): T {
  const commonProps = {
    id: props.name,
    name: props.name,
    value: props.value,
    onChange: props.onChange,
    label: props.label,
    ...(props.errorText && { error: true, errorText: props.errorText }),
  };
  return commonProps as T;
}
